import { FC } from 'react';
import { LocalizedPercent, LocalizedText, Substitutes } from '@mews/framework';

interface RelativeProductOptionsTextProps {
    percentage: number;
    substitutes: Substitutes;
    textKey: Mews.TextKey;
}

const RelativeProductOptionsText: FC<RelativeProductOptionsTextProps> = ({ percentage, substitutes, textKey }) => (
    <span>
        <LocalizedPercent percent={percentage} />
        {textKey && (
            <span>
                {' '}
                <LocalizedText textKey={textKey} firstLowerCase substitutes={substitutes} />
            </span>
        )}
    </span>
);

export default RelativeProductOptionsText;
